module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "content-a",
    attrs: {
      "id": "calibre_toc_2"
    }
  }, [_vm._v("Table of"), _c('span', {
    staticClass: "nobreak3"
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_006#_idTextAnchor137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author Note")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_007#_idTextAnchor139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Parts of This Book")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_008#_idTextAnchor141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part I")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_009#_idTextAnchor143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Live with Intention")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_010#_idTextAnchor145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_011#_idTextAnchor147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rooted Deeply")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_011#_idTextAnchor149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Be You, the More You, the Better")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_011#_idTextAnchor151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Story of Calm Intention")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "linkxxx"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_012#_idTextAnchor154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Live with Intention")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_014#_idTextAnchor156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Day Has a Soundtrack")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_014#_idTextAnchor158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who’s in That Mirror?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_014#_idTextAnchor160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Case for Writing")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_014#_idTextAnchor162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Invest in Consistent Measure")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_014#_idTextAnchor164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Thing and Many Things")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_014#_idTextAnchor166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Road")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "linkxxx"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_015#_idTextAnchor169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Completion Walk to the Edge")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_016#_idTextAnchor171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just Begin It")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_016#_idTextAnchor173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Begin as If You Intend to Finish")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_016#_idTextAnchor175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Call Them Targeted Completion Dates")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_016#_idTextAnchor177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Long-Term Done Lives in Today’s DO")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_016#_idTextAnchor179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Speak Quietly to Yourself")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "linkxxx"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_017#_idTextAnchor182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spirit Listen Hard")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_019#_idTextAnchor185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Listening to Others, I Can Hear the Universe")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_019#_idTextAnchor187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seen OR Unseen, a World Exists Beside Me")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_019#_idTextAnchor189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pay Attention")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_019#_idTextAnchor191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Learn to Listen with a Practiced Pause")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_019#_idTextAnchor193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Origami as Metaphor for Listening Hard")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_019#_idTextAnchor195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Currency of Spirit")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor028"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "linkxxx"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_020#_idTextAnchor198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Health Practice Wellness")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor029"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_021#_idTextAnchor200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-Care: Movement toward Health")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor030"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_021#_idTextAnchor202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Perspective: Choices Are Opportunities")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor031"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_021#_idTextAnchor205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honoring the Health of Others")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor032"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_021#_idTextAnchor207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Car as Metaphor")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor033"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_021#_idTextAnchor209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("So Many Systems, Only One You")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor034"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_021#_idTextAnchor211",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choose Love")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor035"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_021#_idTextAnchor213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turn Yourself Toward a Regular Sabbath")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor036"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_021#_idTextAnchor215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beyond Desiring, Move to Admiring")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor037"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "linkxxx"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_022#_idTextAnchor218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Playfulness Play with Abandon")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor038"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_024#_idTextAnchor220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Key to Brilliance Is Serious: PLAY!")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor039"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_024#_idTextAnchor222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Day Are Simply Meant for Playing")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor040"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_024#_idTextAnchor224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Celebration Has Many Outfits but Always Wears the Same "), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("Comfortable Shoes")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor041"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_024#_idTextAnchor226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sit, Stay, Heal: How One Big Black Dog Trained my Heart")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor042"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "linkxxx"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_025#_idTextAnchor230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gratitude Laugh")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor043"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_027#_idTextAnchor232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Talk About Everything That’s Gone Right in the Day")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor044"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_027#_idTextAnchor234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Change Your Story")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor045"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_027#_idTextAnchor236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Relax into the Natural Embrace of the Day")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor046"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "linkxxx"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_028#_idTextAnchor239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Perspective Fail with Enthusiasm")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor047"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_030#_idTextAnchor241",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willingness to Succeed Partners with the Willingness to Fail")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor048"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_030#_idTextAnchor243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Close That Ledger")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor049"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_030#_idTextAnchor245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broken")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor050"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_030#_idTextAnchor247",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heart Shaped Rocks")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor051"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_030#_idTextAnchor249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When Angels Cry (A Myth That Might Be True)")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor052"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_030#_idTextAnchor251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Because")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor053"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "linkxxx"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_031#_idTextAnchor254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forgiveness Choose with No Regret")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor054"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_033#_idTextAnchor256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hardly Ever")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor055"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_033#_idTextAnchor258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Gift of Grace to Myself")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor056"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_033#_idTextAnchor260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Celebrate Seeing the Door to Change")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor057"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_033#_idTextAnchor262",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Road to Restorative Sleep")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor058"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_033#_idTextAnchor264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forgive, Move On, Learn")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor059"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_033#_idTextAnchor266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Does Forgiveness Imply Tolerating Bad Behavior?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor060"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_033#_idTextAnchor268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Every Ending Draws the Line for the Next Beginning")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor061"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_033#_idTextAnchor270",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Blessing")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor062"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "linkxxx"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_034#_idTextAnchor273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enthusiasm Continue to Learn")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor063"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_036#_idTextAnchor275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Begin Each Day Aligned with Your Enthusiastic Purpose")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor064"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_036#_idTextAnchor277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Learn as If Your Life Depends on It—Because It May")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor065"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_036#_idTextAnchor279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What If I Just Acted Like Everything Was Easy?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor066"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_036#_idTextAnchor281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Every Road’s an Adventure When You Travel with Enthusiasm")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor067"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_036#_idTextAnchor283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Fine Role Model for Enthusiasm and Learning")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor068"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_036#_idTextAnchor285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Praise of Dogs")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor069"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "linkxxx"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_037#_idTextAnchor288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Relationship Appreciate Your Friends")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor070"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_038#_idTextAnchor290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alone into Together")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor071"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_038#_idTextAnchor292",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fully Present for Yourself First")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor072"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_038#_idTextAnchor294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Being Attentive Has So Many Rewards")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor073"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_038#_idTextAnchor296",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Lingering Scent")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor074"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_038#_idTextAnchor298",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stand by Your Family")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor075"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_038#_idTextAnchor300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No Day Is Wasted in Which a Single Moment Is Spent on Love")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor076"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_038#_idTextAnchor302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("If You Have One Friend, You Hold the Hand of the World")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor077"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_038#_idTextAnchor304",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Be Certain")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor078"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_038#_idTextAnchor306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Feather")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor079"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "linkxxx"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_039#_idTextAnchor309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leadership Lead and Follow a Leader")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor080"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_041#_idTextAnchor311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“And” Instead of “Or”")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor081"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_041#_idTextAnchor313",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Talk to People Who Know How to Lead and Follow")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor082"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_041#_idTextAnchor315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leadership Has a Long Reach")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor083"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_041#_idTextAnchor317",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We Are Made of Stars")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor084"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_041#_idTextAnchor319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Parade Named You")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor085"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "linkxxx"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_042#_idTextAnchor322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dream Do What You Love")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor086"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_044#_idTextAnchor324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("May Your Heart Be Awakened to All Your Dreams")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor087"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_044#_idTextAnchor326",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pursue What You Love")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor088"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_044#_idTextAnchor328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Art Does")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor089"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_044#_idTextAnchor330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Go Where Your Thoughts Go")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor090"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_044#_idTextAnchor332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lean Forward into Your Life")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor091"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_044#_idTextAnchor334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When You Jump into Your Dreams, Are Your Eyes Open or Closed?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor092"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_044#_idTextAnchor336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Many Ways to Jump")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor093"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_044#_idTextAnchor338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dream Like You Know Where You’re Going")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor094"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_044#_idTextAnchor340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Willingness Shines the Light on Your Path")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor095"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_044#_idTextAnchor342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Let Imagined Outcomes Drive Chosen Actions")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor096"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_044#_idTextAnchor344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ribbons of Dreams")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor097"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "linkxxx"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_045#_idTextAnchor347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Generosity Live As If This Is All There Is")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor098"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_047#_idTextAnchor349",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We Cannot Know")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor099"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_047#_idTextAnchor351",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Muscle that Builds with Use")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor100"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_047#_idTextAnchor353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recognize the Value in the Priorities of Others")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor101"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_047#_idTextAnchor355",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Single Generosity Enlarges the World")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor102"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_047#_idTextAnchor357",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Just How Busy Are You?")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor103"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_047#_idTextAnchor359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enlist in the Company of Angels")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor104"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_047#_idTextAnchor361",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Future Value")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor105"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_047#_idTextAnchor363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Artful Intention")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor106"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_047#_idTextAnchor365",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Message in a Shell")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor107"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_047#_idTextAnchor367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Here There Be Dragons")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor108"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_047#_idTextAnchor369",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Watch What You Carry")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor109"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_048#_idTextAnchor371",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor110"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_049#_idTextAnchor373",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Remember and Do What Matters")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor111"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor375",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor112"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor113"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor379",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor114"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor381",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor115"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor116"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor385",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor117"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor387",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor118"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor389",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eight")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor119"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor391",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nine")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor120"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor393",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ten")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor121"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor395",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eleven")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor122"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor397",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twelve")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor123"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor399",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirteen")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor124"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor401",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fourteen")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor125"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor403",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifteen")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor126"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor405",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sixteen")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor127"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor407",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seventeen")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor128"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor409",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eighteen")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor129"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nineteen")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor130"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor413",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor131"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor415",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-One")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor132"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link3"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_050#_idTextAnchor417",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twenty-Two")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor133"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_051#_idTextAnchor419",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor134"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_052#_idTextAnchor421",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P.S.")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor135"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/LiveWithIntention_split_053#_idTextAnchor423",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_13"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a4c7a04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/LiveWithIntention_split_005.vue
// module id = 75
// module chunks = 0